export const TAX_DUTIES_SLICE_NAME = '@@taxDuties';

export enum ERateType {
	STANDARD = 'STANDARD',
	REDUCED = 'REDUCED',
}

export enum ESource {
	MANUAL = 'MANUAL',
	UPLOAD = 'UPLOAD',
}
